import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import CmsStorySectionItem from './CmsStorySectionItem';

const CmsStorySectionEditor = ({ content, onChange, weddingId }) => {
  const sections = content?.storySections || [];

  const updateSections = (newSections) => {
    onChange({
      ...content,
      storySections: newSections,
    });
  };

  const handleSectionChange = (index, updatedSection) => {
    const updated = [...sections];
    updated[index] = updatedSection;
    updateSections(updated);
  };

  const handleRemove = (index) => {
    const updated = sections.filter((_, i) => i !== index);
    // Re-number IDs
    updateSections(updated.map((s, i) => ({ ...s, id: i + 1 })));
  };

  const handleMoveUp = (index) => {
    if (index === 0) return;
    const updated = [...sections];
    [updated[index - 1], updated[index]] = [updated[index], updated[index - 1]];
    updateSections(updated.map((s, i) => ({ ...s, id: i + 1 })));
  };

  const handleMoveDown = (index) => {
    if (index === sections.length - 1) return;
    const updated = [...sections];
    [updated[index], updated[index + 1]] = [updated[index + 1], updated[index]];
    updateSections(updated.map((s, i) => ({ ...s, id: i + 1 })));
  };

  const addSection = (type) => {
    const newSection = {
      id: sections.length + 1,
      type,
    };

    switch (type) {
      case 'hero':
        newSection.title = '';
        newSection.subtitle = '';
        newSection.backgroundImage = '';
        newSection.backgroundImageAlt = '';
        break;
      case 'quote':
        newSection.quote = '';
        newSection.author = '';
        break;
      case 'photo':
        newSection.image = '';
        newSection.imageAlt = '';
        newSection.caption = '';
        break;
      case 'text':
        newSection.title = '';
        newSection.content = '';
        break;
      case 'gallery':
        newSection.title = '';
        newSection.images = [];
        break;
      case 'video':
        newSection.videoUrl = '';
        newSection.videoTitle = '';
        break;
      case 'timeline':
        newSection.title = '';
        newSection.events = [];
        break;
    }

    updateSections([...sections, newSection]);
  };

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 shadow-romantic-sm border border-border">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
          <Icon name="Layers" size={20} color="var(--color-primary)" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground">Story Sections</h3>
          <p className="text-xs text-muted-foreground">{sections.length} sections</p>
        </div>
      </div>

      <div className="space-y-2 mb-4">
        {sections.map((section, index) => (
          <CmsStorySectionItem
            key={`${section.id}-${index}`}
            section={section}
            index={index}
            onChange={handleSectionChange}
            onRemove={() => handleRemove(index)}
            onMoveUp={() => handleMoveUp(index)}
            onMoveDown={() => handleMoveDown(index)}
            isFirst={index === 0}
            isLast={index === sections.length - 1}
            weddingId={weddingId}
          />
        ))}
      </div>

      <div className="flex flex-wrap gap-2">
        <span className="text-sm text-muted-foreground self-center mr-2">Add:</span>
        {['hero', 'quote', 'photo', 'text', 'gallery', 'video', 'timeline'].map((type) => (
          <Button key={type} variant="outline" size="sm" onClick={() => addSection(type)}>
            {type.charAt(0).toUpperCase() + type.slice(1)}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default CmsStorySectionEditor;
